import microuniversoApi from "app/api/microuniversoApi";
import { DadosOrdemProducao, DadosOrdemProducaoCombinados, DadosSalvarOrdemProducao, DadosHistoricoOrdemProducao, InsumoOrdemProducao, NecessitaAutorizacaoOrdemProducao } from "app/types/OrdemProducao";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { Abas } from "../abas/Abas";
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container";
import { PesquisaFornecedorContainer } from "../pesquisa-produtos/pesquisa-fornecedor/PesquisaFornecedorContainer";
import { removerComponenteReact, renderizarComponentReact } from "../renderizarOuRemoverComponentReact";
import { OrdemDeProducao } from "./OrdemProducao";
import { DadosOrdemDeProducao } from "./consulta-ordem-de-producao/ConsultaOrdemDeProducao";
import { ConsultarEtapaOrdemProducao } from "./consultar-etapa-ordem-producao/ConsultarEtapaOrdemProducao";
import { ConsultarInsumoOrdemProducao } from "./consultar-insumo-ordem-producao/ConsultarInsumoOrdemProducao";
import { InclusaoInsumoContainer } from "./inclusao-insumo/InclusaoInsumoContainer";
import * as R from "ramda";
import clsx from "clsx";
import { ParametroPorItem } from "app/types/Parametro";
import { obterParametrosPorOidItem } from "app/use-cases/parametro/obterParametros";
import { set } from "date-fns";

const estilosBotoes = require("../../estilos/botoes.module.scss").default;
const estilosInputs = require('../../estilos/inputs.module.scss').default

export type OrdemDeProducaoContainerProps = {
    onVoltar: () => void
    onRemover: () => boolean
    passos: Dict<string, () => void>;
    ordemProducaoSelecionado: Partial<DadosOrdemDeProducao>

    ordemProducao?: Partial<DadosOrdemProducaoCombinados>
    terceirizado?: boolean
    dadosOrdemProducao?: Partial<DadosOrdemProducao>
    mostrarAutorizacao?: Partial<NecessitaAutorizacaoOrdemProducao>
    senha?: string
    historicoOrdemProducao?: Partial<DadosHistoricoOrdemProducao>
}

type NomesAbas = "Dados Básicos" | "Insumos" | "Etapa Produção";

export const OrdemDeProducaoContainer = (props: OrdemDeProducaoContainerProps) => {
    const [ordemProducao, setOrdemProducao] = useState<Partial<DadosOrdemProducaoCombinados>>(props.ordemProducao)
    const [insumosSelecionados, setInsumosSelecionados] = useState<InsumoOrdemProducao[]>([])
    const [selecionadoTerceirizado, setSelecionadoTerceirizado] = useState<boolean>(props.terceirizado ?? false)
    const [dadosOrdemProducao, setDadosOrdemProducao] = useState<Partial<DadosOrdemProducao>>(props.dadosOrdemProducao ?? {})
    const [mostrarAutorizacao, setMostrarAutorizacao] = useState<Partial<NecessitaAutorizacaoOrdemProducao>>(props.mostrarAutorizacao);
    const [historicoOrdemProducao, setHistoricoOrdemProducao] = useState<Partial<DadosHistoricoOrdemProducao>>(props.historicoOrdemProducao ?? {})
    const [abaSelecionada, setAbaSelecionada] = useState<NomesAbas>("Dados Básicos");
    const [abas, setAbas] = useState<{ nome: string }[]>([])
    const [senha, setSenha] = useState<string>(props.senha ?? null)
    const [parametrosPorFilial, setParametrosPorFilial] = useState<ParametroPorItem[]>([])
    const [processando, setProcessando] = useState(false)

    const passosInterno = useRef<Dict<string, () => void>>(new Dict())

    const onObterDados = async () => {
        try {
            globalMU.blockUI();
            const resposta = await microuniversoApi.OrdemProducao.ObterDadosOrdemProducao({
                CodigoItemPedido: props.ordemProducaoSelecionado.CodigoItem,
                CodigoOrdemProducao: props.ordemProducaoSelecionado.CodigoOrdemProducao,
                CodigoProduto: props.ordemProducaoSelecionado.CodigoProduto,
                QuantidadeItem: props.ordemProducaoSelecionado.QuantidadeItem,
                CodigoFilial: props.ordemProducaoSelecionado.CodigoFilialOP,
                Nivel: props.ordemProducaoSelecionado.Nivel

            }, props.ordemProducaoSelecionado.NumeroPedido);

            if (!("HasErrors" in resposta)) {

                if (props.ordemProducaoSelecionado?.CodigoOrdemProducao > 0) {
                    setOrdemProducao(resposta.Dados)
                } else {
                    setOrdemProducao(resposta.DadosInclusao)
                }

                setDadosOrdemProducao(resposta)
            } else if (resposta["Error"]["Error"]?.includes("já está em uso por outro usuário")) {
                setOrdemProducao(null)
                onVoltar()
            }
        }
        catch (e) {
            tratamentoErroPadrao(e)
            setOrdemProducao(null)
        }
        finally {
            globalMU.unblockUI();
            setProcessando(false)
        }
    }

    const onExcluirControleDeExclusividade = async () => {
        try {
            globalMU.blockUI()
            await microuniversoApi.Comum.excluirControleDeExclusividade(props.ordemProducaoSelecionado.NumeroPedido.toString(), "PEDICLICAD");
        }
        catch (erro) {
            tratamentoErroPadrao(erro);
        }
        finally {
            globalMU.unblockUI()
        }
    }

    const onPesquisaFornecedor = () => {
        renderizarComponentReact(<PesquisaFornecedorContainer
            onSelecionadoFornecedor={(codigoFornecedor, nomeFornecedor) => {
                renderizarComponentReact(<OrdemDeProducaoContainer {...props}
                    ordemProducao={{
                        ...ordemProducao,
                        CodigoFornecedor: Number(codigoFornecedor),
                        NomeFornecedor: nomeFornecedor
                    }}
                    historicoOrdemProducao={historicoOrdemProducao}
                    senha={senha}
                    mostrarAutorizacao={mostrarAutorizacao}
                    terceirizado={selecionadoTerceirizado} dadosOrdemProducao={dadosOrdemProducao} />, "ordem-de-producao-region", true)

                setOrdemProducao({
                    ...ordemProducao,
                    CodigoFornecedor: Number(codigoFornecedor),
                    NomeFornecedor: nomeFornecedor
                })

            }}

            onVoltar={onRenderizarOrdemProducao}
            passos={passosInterno.current}
            regiaoRenderizada="ordem-de-producao-region" />, "ordem-de-producao-region", true)
    }

    const onRenderizarOrdemProducao = () => renderizarComponentReact(
        <OrdemDeProducaoContainer 
            {...props} 
            dadosOrdemProducao={dadosOrdemProducao} 
            ordemProducao={ordemProducao}
            terceirizado={selecionadoTerceirizado} 
            senha={senha} 
            historicoOrdemProducao={historicoOrdemProducao}
            mostrarAutorizacao={mostrarAutorizacao} />,
        "ordem-de-producao-region", true
    )

    const onPassoSelecionado = (passo: string) => {
        
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
        ordemProducao != null && onExcluirControleDeExclusividade();
    }

    const onAlterarQuantidade = (quantidade: number, codigoProduto: string, quantidadeOriginal: number) => {
        const novoDadosInsumoOrdemProducao = [...dadosOrdemProducao?.DadosInsumoOrdemProducao];

        const item = dadosOrdemProducao?.DadosInsumoOrdemProducao.find((x) => x.CodigoProdutoInsumo == codigoProduto)
        const itemIndex = dadosOrdemProducao?.DadosInsumoOrdemProducao.findIndex((x) => x.CodigoProdutoInsumo == codigoProduto)
        const quantidadeMinima = item.QuantidadeMinima * ordemProducao.Quantidade;
        const quantidadeMaxima = item.QuantidadeMaxima * ordemProducao.Quantidade;

        if ((quantidade < quantidadeMinima) || (quantidade > quantidadeMaxima)) {

            globalMU.showWarnMessage(`Informe uma quantidade entre a quantidade mínima: ${globalMU.formatarValorNumerico(quantidadeMinima, 3, false)} e quantidade máxima: ${globalMU.formatarValorNumerico(quantidadeMaxima, 3, false)}`)
            item.QuantidadeFinal = quantidadeOriginal;
            novoDadosInsumoOrdemProducao[itemIndex] = item;
            setDadosOrdemProducao({ ...dadosOrdemProducao, DadosInsumoOrdemProducao: novoDadosInsumoOrdemProducao })

        } else {
            item.QuantidadeFinal = quantidade;
            
            if (quantidadeOriginal > quantidade){
                item.QuantidadeDisponivel = item.QuantidadeDisponivel + (quantidadeOriginal - quantidade)
            }else{
                item.QuantidadeDisponivel = item.QuantidadeDisponivel - (quantidade - quantidadeOriginal)
            }
            
            novoDadosInsumoOrdemProducao[itemIndex] = item
            setDadosOrdemProducao({ ...dadosOrdemProducao, DadosInsumoOrdemProducao: novoDadosInsumoOrdemProducao })
        }
    }

    const onSalvar = async () => {
        try {
            globalMU.blockUI()

            const resposta = await microuniversoApi.OrdemProducao.SalvarOrdemProducao({
                Dados: {
                    ...ordemProducao as DadosSalvarOrdemProducao,
                    CodigoOrdemProducao: ordemProducao.Id,
                    NumeroOrdemEntrada: ordemProducao.NumeroEntrada,
                },
                DadosInsumoOrdemProducao: dadosOrdemProducao?.DadosInsumoOrdemProducao,
                SenhaLiberacao: senha,
                DadosHistoricoOrdemProducao: historicoOrdemProducao
            })

            if (resposta?.Resultado?.Sucesso) {
                globalMU.showSuccessMessage(resposta?.Resultado?.MensagemSucesso)
                onVoltar()
            }
        }
        catch (erro) {
            tratamentoErroPadrao(erro);
        }
        finally {
            globalMU.unblockUI()
        }
    }

    const onVerificarAutorizacaoSalvar = async () => {
        try {
            setProcessando(true)
            globalMU.blockUI()

            if (mostrarAutorizacao?.NecessitaAutorizacao && globalMU.isNotNullOrEmpty(senha)) {
                onSalvar()
                return
            }

            const resultado = await microuniversoApi.OrdemProducao.VerificarAutorizacaoOrdemProducao({
                Insumos: dadosOrdemProducao.DadosInsumoOrdemProducao,
                NumeroPedido: ordemProducao.NumeroPedido,
                IdSituacao: ordemProducao.CodigoSituacao
            });

            if (resultado.NecessitaAutorizacao) {
                setMostrarAutorizacao(resultado)
                setHistoricoOrdemProducao({
                    ...historicoOrdemProducao,
                    InsumosPendentes: (historicoOrdemProducao.InsumosPendentes ?? []).concat(resultado.CodigosInsumos)
                })
            } else {
                onSalvar()
            }
        }
        catch (erro) {
            tratamentoErroPadrao(erro);
        }
        finally {
            globalMU.unblockUI()
            setProcessando(false)
        }
    }

    const onRenderizarInclusaoInsumos = () => renderizarComponentReact(
        <InclusaoInsumoContainer
            filtros={{
                codigoProduto: ordemProducao.CodigoProduto,
                filial: ordemProducao.CodigoFilial,
                insumosJaInformados: dadosOrdemProducao.DadosInsumoOrdemProducao,
                quantidade: ordemProducao.Quantidade,
            }}
            onInserirInsumos={(insumos: InsumoOrdemProducao[]) => {
                renderizarComponentReact(<OrdemDeProducaoContainer {...props}
                    dadosOrdemProducao={{
                        ...dadosOrdemProducao,
                        DadosInsumoOrdemProducao: dadosOrdemProducao?.DadosInsumoOrdemProducao?.concat(insumos)
                    }}
                    historicoOrdemProducao={{
                        ...historicoOrdemProducao,
                        InsumosAdicionados: historicoOrdemProducao?.InsumosAdicionados
                            ? historicoOrdemProducao.InsumosAdicionados.concat(insumos.map((x) => x.CodigoProdutoInsumo))
                            : insumos.map((x) => x.CodigoProdutoInsumo)
                    }}
                    senha={senha}
                    mostrarAutorizacao={mostrarAutorizacao}
                    ordemProducao={ordemProducao}
                    terceirizado={selecionadoTerceirizado} />, "ordem-de-producao-region", true)
            }}
            onRemover={() => removerComponenteReact("pesquisar-pedidos-region")}
            onVoltar={onRenderizarOrdemProducao}
            passos={passosInterno.current} />, "ordem-de-producao-region", true
    )

    const atualizarAbas = () => {
        const abasPermitidas = [
            { nome: "Dados Básicos" },
            { nome: "Insumos" },
            { nome: "Etapa Produção" },
        ].filter(aba => aba.nome != undefined)
        setAbas(abasPermitidas)
        setAbaSelecionada(abasPermitidas[0] ? abasPermitidas[0].nome as NomesAbas : "Dados Básicos")
    }

    const onDadosModificado = (dado: Partial<DadosOrdemProducaoCombinados>) => {
        setOrdemProducao(dado)
    }

    const onSelecionarInsumo = (insumo: InsumoOrdemProducao) => {
        if (insumosSelecionados?.find((item) => item.CodigoProdutoInsumo == insumo.CodigoProdutoInsumo) != undefined) {
            setInsumosSelecionados(
                R.filter((c) => c.CodigoProdutoInsumo != insumo.CodigoProdutoInsumo, insumosSelecionados)
            );
            setInsumosSelecionados(
                R.filter((c) => c.CodigoProdutoInsumo != insumo.CodigoProdutoInsumo, insumosSelecionados)
            );
        } else {
            setInsumosSelecionados(insumosSelecionados.concat(insumo));
            setInsumosSelecionados(insumosSelecionados.concat(insumo));
        }
    }

    const onRemoverInsumo = () => {
        const novosInsumosPodemSerCancelados = insumosSelecionados.filter((x) => x.QuantidadeFormula <= 0);
        const novosInsumosNaoPodemSerCancelados = insumosSelecionados.filter((x) => x.QuantidadeFormula > 0);

        if (novosInsumosNaoPodemSerCancelados.length > 0) {
            const listaMensagem = novosInsumosNaoPodemSerCancelados.map((x) => `O insumo ${x.CodigoProdutoInsumo} não pode ser removido`);
            globalMU.showWarnMessage(listaMensagem);
        }

        const novosDadosInsumoOrdemProducao = dadosOrdemProducao.DadosInsumoOrdemProducao.filter((insumo) =>
            !novosInsumosPodemSerCancelados.some((x) => x.CodigoProdutoInsumo === insumo.CodigoProdutoInsumo));

        const insumosComuns = insumosSelecionados.filter((insumo) => historicoOrdemProducao.InsumosAdicionados.includes(insumo.CodigoProdutoInsumo))
            .map((insumo) => insumo.CodigoProdutoInsumo);

        setHistoricoOrdemProducao({
            ...historicoOrdemProducao,
            InsumosRemovidos: (historicoOrdemProducao.InsumosRemovidos ?? []).filter((codigo) => !insumosComuns.includes(codigo)),
            InsumosAdicionados: (historicoOrdemProducao.InsumosAdicionados ?? []).filter((codigo) => !insumosComuns.includes(codigo)),
        });

        setInsumosSelecionados(novosInsumosNaoPodemSerCancelados);
        setDadosOrdemProducao({ ...dadosOrdemProducao, DadosInsumoOrdemProducao: novosDadosInsumoOrdemProducao });
    };

    const atualizarOidFilialUsuarioLogadoEParamentro = async () => {
        const oidFilialUsuarioLogado = await microuniversoApi.Usuario.obterOidFilialUsuarioLogado()

        const response = await obterParametrosPorOidItem({
            nomes: ["PERMITE_PERSONALIZACAO_ORDEM_PRODUCAO"],
            oidItem: oidFilialUsuarioLogado
        })
        setParametrosPorFilial(response)

    }

    const valorParametro = (nome: string) => parametrosPorFilial.find((p) => p.Nome == nome)?.Valor;

    useEffect(() => {
        setProcessando(false)
        passosInterno.current.set("Ordem de Produção", () => onRenderizarOrdemProducao())
        atualizarAbas()
        atualizarOidFilialUsuarioLogadoEParamentro()
        
        props.ordemProducao == null && onObterDados()
    }, [])

    useEffect(() => {
        $.connection.hub.disconnected(function () {
            console.log("$.connection.hub.disconnected")
        });
    }, [])


    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno?.current?.keysToList()}
                id="OrdemProducaoContainer"
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
                processando={processando}
            />

            <div className="_mt-2 _border-b _border-solid _border-[#ddd] _shadow-[0_6px_rgb(0_0_0/3%)]">
                <Abas
                    abas={abas}
                    id="OrdemProducaoContainer_Abas"
                    nomeAbaSelecionada={abaSelecionada}
                    onAbaSelecionada={(nome) => setAbaSelecionada(nome as NomesAbas)}
                />
            </div>

            {abaSelecionada == "Dados Básicos" && <OrdemDeProducao
                listaLinhaProducao={dadosOrdemProducao?.ListaLinhaProducao}
                ordemProducao={ordemProducao}
                codigoOrdemProducao={props.ordemProducaoSelecionado?.CodigoOrdemProducao}
                selecionadoTerceirizado={selecionadoTerceirizado}
                onSelecionadoTerceirizado={setSelecionadoTerceirizado}
                onExcluirFornecedor={() => setOrdemProducao({
                    ...ordemProducao,
                    CodigoFornecedor: null,
                    NomeFornecedor: ''
                })}
                onDadosModificado={onDadosModificado}
                onPesquisaFornecedor={onPesquisaFornecedor}
                processando={processando}
            />
            }

            {abaSelecionada == "Insumos" && <ConsultarInsumoOrdemProducao
                listaQuantidade={dadosOrdemProducao?.DadosInsumoOrdemProducao?.map((x) => ({
                    codigo: x.CodigoProdutoInsumo,
                    quantidade: x.QuantidadeFinal,
                }))}
                insumosSelecionados={insumosSelecionados}
                onSelecionarInsumo={onSelecionarInsumo}
                situacaoOrdemProcucao={ordemProducao.CodigoSituacao}
                dadosInsumoOrdemProducao={dadosOrdemProducao?.DadosInsumoOrdemProducao}
                onIncluirInsumo={onRenderizarInclusaoInsumos}
                onRemoverInsumo={onRemoverInsumo}
                onAlterarQuantidade={onAlterarQuantidade}
                permitirPersonalizacaoOrdemProducao={valorParametro("PERMITE_PERSONALIZACAO_ORDEM_PRODUCAO") == "S"}
            />
            }

            {abaSelecionada == "Etapa Produção" && <ConsultarEtapaOrdemProducao dadosEtapaOrdemProducao={dadosOrdemProducao.DadosEtapaProducaoOrdemProducao} />}

            {mostrarAutorizacao?.NecessitaAutorizacao && (
                <div className="_my-4 _bg-[#e4e6e8] _p-4">
                    <div className="_flex _items-center _mt-2 _w-full">
                        <p>{mostrarAutorizacao?.Mensagem}</p>
                        <label className={clsx("_w-1/5 _text-right _font-normal _mb-0 _p-2", estilosInputs.labelObrigatorio)}> Senha</label>
                        <input type="password" value={(senha) ?? ""} className={clsx("_ml-2", estilosInputs.inputPadrao)}
                            autoComplete="off"
                            aria-autocomplete="none"
                            onChange={(e) => setSenha(e.target.value)}
                        />
                    </div>
                </div>
            )}

            <div className="_flex">
                <button className={`_m-2 no-global-button ${estilosBotoes.botaoPrimario}`}
                    style={{ maxHeight: "45px" }}
                    id="OrdemProducaoContainer_BotaoSalvar"
                    disabled={processando || ( mostrarAutorizacao?.NecessitaAutorizacao && globalMU.isNullOrEmpty(senha))}
                    onClick={() => onVerificarAutorizacaoSalvar()}>
                    Salvar
                </button>
            </div>
            <section style={{ marginBottom: "100px" }} />
        </>
    )
}